import styled from 'styled-components';
import { Box, Image as WikrImage } from '@user-portal/wikr-components';

import { color } from 'theme/selectors';
import mediaQueries from 'theme/mediaQueries';

export const Container = styled(Box)`
    border-bottom: 1px solid ${color('surface-hovered')};
`;

export const FlexWrapper = styled(Box)`
    display: flex;
    align-items: center;
    max-width: 432px;
    margin: 0 auto;

    ${mediaQueries.tabletLandscape} {
        margin: 0 96px;
    }

    ${mediaQueries.desktop} {
        max-width: 456px;
    }
`;

export const ContentWrapper = styled(FlexWrapper)`
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    > * {
        width: 100%;
    }
`;

export const AvatarWrapper = styled(FlexWrapper)`
    gap: 16px;
    ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
`;

export const Image = styled(WikrImage)`
    width: 56px;
`;
